module.exports = __webpack_public_path__ + "img/FreeAgent.58495006.svg";